import { registerFunctions as registerFunctionsOrigin } from '@cloudbase/functions';
import { ICloudbase } from '@cloudbase/types';

export const registerFunctions = registerFunctionsOrigin as (app: ICloudbase) => void;

try {
  (window as any).registerFunctions = registerFunctions
} catch (e) {}